/**
 * 事件发送前的最大缓存数
 */
export const MAX_CACHE_LEN = 5;

/**
 * 发送缓存事件前的最大等待时间（毫秒）
 */
export const MAX_WAITING_TIME = 30000;

/**
 * 存储的用户UUID
 */
export const UUID = 'track_uuid';

/**
 * 默认长任务阈值 (ms)
 */
export const DEFAULT_LONG_TASK_THRESHOLD = 100;

/**
 * 默认资源加载阈值 (ms)
 */
export const DEFAULT_RESOURCE_THRESHOLD = 1000;

/**
 * 默认 INP 阈值 (ms)
 */
export const DEFAULT_INP_THRESHOLD = 200;
